/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import { components } from '@glowingblue-orell-thalia-common';

const { MobileTourCard } = components;
import { slug } from '../../common';
import ReviewsTour from '../components/ReviewsTour';

export const startReviewsTour = () => {
	// The container is appended to `<body>` by the `mount` patch below.
	m.mount(document.getElementById('reviews-tour')!, ReviewsTour);
};

export default function () {
	extend(app, 'mount', () => {
		const reviewsTour = document.createElement('div');
		reviewsTour.id = 'reviews-tour';
		document.body.appendChild(reviewsTour);
	});

	// The explicit `this` is what grants access to the protected `cardAttrs` below.
	extend(MobileTourCard.prototype, 'oninit', function (this: InstanceType<typeof MobileTourCard>) {
		let { cardId } = this.attrs;
		if (!cardId.startsWith('reviews.')) {
			return;
		}

		cardId = cardId.replace('reviews.', '');

		const isThalia = app.forum.attribute('isThalia');
		const imgPath = `/assets/extensions/${slug}/tour${isThalia ? '_thalia' : ''}/`;

		// `cardId` is one of the ids ReviewsTour registers, so the keys resolved below are
		// glowingblue-orell-rezensionen.forum.tour.steps.<id>.{title,text.short,text.full} for
		// <id> in: link-account, bulk-export, single-export, updates, status, more.
		this.cardAttrs = {
			id: cardId,
			image: `${imgPath}${cardId}.png`,
			title: extractText(app.translator.trans(`glowingblue-orell-rezensionen.forum.tour.steps.${cardId}.title`)),
			textShort: extractText(app.translator.trans(`glowingblue-orell-rezensionen.forum.tour.steps.${cardId}.text.short`)),
			textFull: extractText(app.translator.trans(`glowingblue-orell-rezensionen.forum.tour.steps.${cardId}.text.full`)),
		};

		if (this.cardAttrs.textShort === this.cardAttrs.textFull) {
			this.cardAttrs.textFull = '';
		}
	});
}
